module.exports = __webpack_public_path__ + "static/img/jigou-shenyang-top.c5c7258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-shenyang-top.png
// module id = Ykda
// module chunks = 2